export const McKSansMedium: string = "McKinseySansMedium"
export const McKSansLight: string = "McKinseySansLight"
export const McKSansRegular: string = "McKinseySansRegular"